import React, { useEffect } from 'react';
import { StyledTabSetComponents } from './TabSetComponents.styles';
import Switch from '../Switch';
import Form, { useForm } from '../../molecules/Form';
import Button from '../../molecules/Button';
import Field from '../Field';
import commonService from '../../../services/commonService';
import UploadFile from '../../molecules/UploadFile';

const Printer = ({ title, childBorder, data, deviceId, completeData, onSubmit }) => {
  const [form] = useForm();
console.log(data);
const handleSubmit = async e => {
  const payload = {
    id: deviceId,
    configuration: {
      ...completeData?.configuration,
      printer: {
        ...completeData?.configuration?.printer,
        _l: e?.Lock,
        _v: e?.visible,
        both_receipt: {
          value: e?.bothReceipt,
        },
        pre_print: {
          value: e?.prePrint,
        },
        receipt_footer_lines: {
          line_1: {
            en: e?.footerLine1en,
            fr: e?.footerLine1fr,
          },
          line_2: {
            en: e?.footerLine2en,
            fr: e?.footerLine2fr,
          },
          line_3: {
            en: e?.footerLine3en,
            fr: e?.footerLine3fr,
          },
          line_4: {
            en: e?.footerLine4en,
            fr: e?.footerLine4fr,
          },
          value: e?.disableFooterLine,
        },
        receipt_header_lines: {
          line_1: e.headerLine1 ? e.headerLine1 : '',
          line_2: e?.storeName,
          line_3: e?.storeAddress1,
          line_4: e?.storeAddress2,
          line_5: {
            en: e?.headerLine5en,
            fr: e?.headerLine5fr,
          },
          line_6: {
            en: e?.headerLine6en,
            fr: e?.headerLine6fr,
          },
        },
      },
    },
  };

  onSubmit(payload);
};
const uploadImageToCloud = async file => {
  try {
    const formData = new FormData();
    formData.append('image', file);
    const response = await commonService.uploadImage(formData, 'POST');
    return response;
  } catch (error) {
    // console.log(error);
    return false;
  }
};
useEffect(() => {
  form.setFieldsValue({
    visible: data?._v,
    Lock: data?._l,
    prePrint: data?.pre_print?.value,
    bothReceipt: data?.both_receipt?.value,
    merchantReceipt: data?.pre_print?.value,
    customerReceipt: data?.pre_print?.value,
    disableFooterLine: data?.receipt_footer_lines?.value,
    footerLine1en: data?.receipt_footer_lines?.line_1?.en,
    footerLine1fr: data?.receipt_footer_lines?.line_1?.fr,
    footerLine2en: data?.receipt_footer_lines?.line_2?.en,
    footerLine2fr: data?.receipt_footer_lines?.line_2?.fr,
    footerLine3en: data?.receipt_footer_lines?.line_3?.en,
    footerLine3fr: data?.receipt_footer_lines?.line_3?.fr,
    footerLine4en: data?.receipt_footer_lines?.line_4?.en,
    footerLine4fr: data?.receipt_footer_lines?.line_4?.fr,
    storeName: data?.receipt_header_lines?.line_2,
    storeAddress1: data?.receipt_header_lines?.line_3,
    storeAddress2: data?.receipt_header_lines?.line_4,
    headerLine1: data?.receipt_header_lines?.line_1,
    headerLine5en: data?.receipt_header_lines?.line_5?.en,
    headerLine5fr: data?.receipt_header_lines?.line_5?.fr,
    headerLine6en: data?.receipt_header_lines?.line_6?.en,
    headerLine6fr: data?.receipt_header_lines?.line_6?.fr,
  });
}, [data, form]);

return (
  <StyledTabSetComponents form={form} onSubmit={handleSubmit} $childBorder={childBorder}>
    <div className="tab-body-header">
      <strong className="title">{title}</strong>
      <div className="switch-wrap">
        <Form.Item label="Visible" name="visible">
          <Switch />
        </Form.Item>
        <Form.Item label="Lock" name="Lock">
          <Switch label="Lock" />
        </Form.Item>
      </div>
    </div>
    <div className="tab-body-body noflex">
      <div className="printer-switch">
        <Form.Item label="Pre - Print" name="prePrint">
          <Switch />
        </Form.Item>
        <Form.Item label="Both Receipt" name="bothReceipt">
          <Switch />
        </Form.Item>
        {/* <Form.Item label="Merchant Receipt" name="merchantReceipt">
            <Switch />
          </Form.Item>
          <Form.Item label="Customer Receipt" name="customerReceipt">
            <Switch />
          </Form.Item> */}
      </div>
      <div className="wrap">
        <strong className="title noMb">Receipt Footer Lines</strong>
        <Form.Item label="Disable / Enable" name="disableFooterLine">
          <Switch />
        </Form.Item>
      </div>
      <div className="footer-col-wrap">
        <div className="footer-col">
          <strong className="col-title">Footer Line 1</strong>
          <div className="form-control-custom">
            <Form.Item label="English" type="text" rounded name="footerLine1en" lg placeholder="">
              <Field />
            </Form.Item>
            <Form.Item label="French" type="text" rounded name="footerLine1fr" lg placeholder="">
              <Field />
            </Form.Item>
          </div>
        </div>
        <div className="footer-col">
          <strong className="col-title">Footer Line 2</strong>
          <div className="form-control-custom">
            <Form.Item label="English" type="text" rounded name="footerLine2en" lg placeholder="">
              <Field />
            </Form.Item>
            <Form.Item label="French" type="text" rounded name="footerLine2fr" lg placeholder="">
              <Field />
            </Form.Item>
          </div>
        </div>
        <div className="footer-col">
          <strong className="col-title">Footer Line 3</strong>
          <div className="form-control-custom">
            <Form.Item label="English" type="text" rounded name="footerLine3en" lg placeholder="">
              <Field />
            </Form.Item>
            <Form.Item label="French" type="text" rounded name="footerLine3fr" lg placeholder="">
              <Field />
            </Form.Item>
          </div>
        </div>
        <div className="footer-col">
          <strong className="col-title">Footer Line 4</strong>
          <div className="form-control-custom">
            <Form.Item label="English" type="text" rounded name="footerLine4en" lg placeholder="">
              <Field />
            </Form.Item>
            <Form.Item label="French" type="text" rounded name="footerLine4fr" lg placeholder="">
              <Field />
            </Form.Item>
          </div>
        </div>
      </div>
      <div className="wrap">
        <strong className="title noMb">Receipt Header Lines</strong>
      </div>
      <div className="footer-col-wrap">
        <div className="upload-img-wrap">
          <Form.Item
            type="img"
            rounded
            name="headerLine1"
            lg
            placeholder=""
            uploadTitle="Change Logo"
            disc="Header Line 1 (Logo)"
            upload={uploadImageToCloud}
            img={data?.receipt_header_lines?.line_1}
            onChange={e =>
              form.setFieldsValue({
                headerLine1: e,
              })
            }>
            <Field />
          </Form.Item>
          {/* <UploadFile type="img" onChange={e => uploadImageToCloud(e).then(res => console.log(res))} /> */}
        </div>
        <div className="header-col-wrap">
          <div className="footer-col">
            <strong className="col-title">Header Line 2 (Store Name)</strong>
            <div className="form-control-custom">
              <Form.Item label="Store Name" type="text" rounded name="storeName" lg placeholder="">
                <Field />
              </Form.Item>
            </div>
          </div>
          <div className="footer-col">
            <strong className="col-title">Header Line 3 (Store Address 1)</strong>
            <div className="form-control-custom">
              <Form.Item label="Store Address" type="text" rounded name="storeAddress1" lg placeholder="">
                <Field />
              </Form.Item>
            </div>
          </div>
        </div>
        <div className="footer-col">
          <strong className="col-title">Header Line 4 (Store Address 2)</strong>
          <div className="form-control-custom">
            <Form.Item label="Store Address" type="text" rounded name="storeAddress2" lg placeholder="">
              <Field />
            </Form.Item>
          </div>
        </div>
        <div className="footer-col">
          <strong className="col-title">Header Line 5</strong>
          <div className="form-control-custom">
            <Form.Item label="English" type="text" rounded name="headerLine5en" lg placeholder="">
              <Field />
            </Form.Item>
            <Form.Item label="French" type="text" rounded name="headerLine5fr" lg placeholder="">
              <Field />
            </Form.Item>
          </div>
        </div>
        <div className="footer-col">
          <strong className="col-title">Header Line 6</strong>
          <div className="form-control-custom">
            <Form.Item label="English" type="text" rounded name="headerLine6en" lg placeholder="">
              <Field />
            </Form.Item>
            <Form.Item label="French" type="text" rounded name="headerLine6fr" lg placeholder="">
              <Field />
            </Form.Item>
          </div>
        </div>
      </div>
    </div>
    <div className="submission-wrapper">
      <Button width="140px">Confirm</Button>
    </div>
  </StyledTabSetComponents>
);
};

export default Printer;
